import { render, staticRenderFns } from "./UdefEventCardVertical.vue?vue&type=template&id=31294c92&scoped=true&"
import script from "./UdefEventCardVertical.vue?vue&type=script&lang=js&"
export * from "./UdefEventCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./UdefEventCardVertical.vue?vue&type=style&index=0&id=31294c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31294c92",
  null
  
)

export default component.exports